import {Helper} from "@nolimitcity/promo-panel/bin/utils/Helper";
import {ASMainGamePickOptions, WINTYPE} from "@nolimitcity/promo-panel/bin/enums/ASEnums";
import {
    ActionSpinOptions,
    ActionSpinSound,
    ASWinData,
    PromoPanelGameConfiguration
} from "@nolimitcity/promo-panel/bin/interfaces/ASInterfaces";
import {ITheRaveGameData} from "./server/data/ITheRaveData";
import {TheRave} from "./TheRave";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {TheRaveGameMode} from "./gameflow/TheRaveGameMode";
import {TheRaveSound} from "./sound/TheRaveSound";

export class TheRavePromoPanelConfig implements PromoPanelGameConfiguration {
    private wasFeatureBuy: boolean = false;

    constructor() {
    }


    public getActionSpinOptions(): ActionSpinOptions {
        return {
            gameName: "TheRave",
            hasActionSpin: true,
            graphics: {backgroundTextureName: "minBackground"},
            mainGame: {
                header: () => TheRave.apiPlugin.translations.translate("xBET"),
                options: [
                    {name: "NORMAL", id: 0, image: "inactive.png"},
                    {name: "BOOSTED_BET", id: 1, image: "active.png"}
                ],
                type: ASMainGamePickOptions.BOOSTED_BET
            },
            getParsedData: (response: ITheRaveGameData, bet: number, prevResponse: ITheRaveGameData): ASWinData => {
                const parsedData: ASWinData = {
                    totalWin: response.accumulatedRoundWin,
                    wasFeatureBuy: response.wasFeatureBuy,
                    freeSpinTriggeredThisSpin: this.isFreeSpinTriggered(response),
                    totalSpinWinnings: response.totalSpinWinnings,
                    isBigWin: this.isBigWin(response),
                    winType: WINTYPE.NORMAL,
                    featureName: this.getFeatureName(response),
                    isRoundComplete: this.isRoundComplete(response),
                    isBonusEnd: this.isBonusEnd(response),
                    isWinCapHit: response.maximumWinAchieved,

                }
                return parsedData;
            }
        };
    }

    public onActionSpinPlaySound(trigger: ActionSpinSound): void {
        if (trigger == ActionSpinSound.WIN) {
            TheRave.sound.playEffect(TheRaveSound.AS_WIN);
        } else if (trigger == ActionSpinSound.BIG_WIN) {
            TheRave.sound.playEffect(TheRaveSound.AS_WIN_BIG);
        }
    }

    private isBigWin(response: ITheRaveGameData): boolean {
        let win: number = response.totalSpinWinnings;

        if (this.wasFeatureBuy) {
            const betPrice = this.getBuyFeaturePrice(response);
            let winRatio: number = Helper.ceilToDecimals((win / betPrice), 2);
            return winRatio >= 1;
        }

        let winRatio: number = Helper.ceilToDecimals((win / parseFloat(response.playedBetValue)), 2);
        return winRatio >= 15;
    }

    private getBuyFeaturePrice(response: ITheRaveGameData): number {
        let betLevel = TheRave.apiPlugin.freeBets.hasFreeBets() ? TheRave.apiPlugin.freeBets.getBet() : TheRave.apiPlugin.betLevel.getLevel();
        let price: number = parseFloat(response.playedBetValue) || parseFloat(betLevel);
        if (TheRave.buyFeatureName) {
            for (let index = 0; index < TheRave.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheRave.model.initData.featureBuyTimesBetValue[index].name === TheRave.model.buyFeatureName) {
                    price *= TheRave.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    private getSpinWin(response: ITheRaveGameData, bet: number, prevData: ITheRaveGameData): number {
        return response.totalSpinWinnings;
    }

    private isFreeSpinTriggered(response: ITheRaveGameData): boolean {
        if (response.freespinTriggeredThisSpin && response.featureBet) {
            this.wasFeatureBuy = true;
        }
        return response.freespinTriggeredThisSpin;
    }

    private getFeatureName(response: ITheRaveGameData): string {
        if (response.mode === GameMode.NORMAL && response.nextMode !== GameMode.NORMAL) {
            if (response.nextMode === GameMode.FREESPIN) {
                return "MURDER ON THE DANCE FLOOR";
            } else {
                return "GOD IS A DJ";
            }
        } else {
            if (response.mode === GameMode.FREESPIN) {
                return "MURDER ON THE DANCE FLOOR";
            } else if (response.mode === GameMode.FREESPIN_SUPER) {
                return "GOD IS A DJ";
            } else {
                return response.mode;
            }
        }
    }

    private isRoundComplete(response: ITheRaveGameData): boolean {
        return true;
    }

    private isBonusEnd(response: ITheRaveGameData): boolean {
        const returnVal: boolean = ((response.nextMode === GameMode.NORMAL) && (response.mode === GameMode.FREESPIN || response.mode === GameMode.FREESPIN_SUPER || response.mode === TheRaveGameMode.FREESPIN_SUPER));
        if (returnVal) {
            this.wasFeatureBuy = false;
        }
        return returnVal;
    }


}